import Main_Content_Header from "./Main_Content_Header";
import { Outlet } from "react-router-dom";
import {connect} from "react-redux";
import React from "react";

const Main_Content = (props) => {
    return(
        <div className={`main_content main_content_border_${props.color_background}`}>
            <Main_Content_Header />
            <Outlet />
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        color_background: state.getColorBackground.color_background
    }
}
export default connect(mapStateToProps)(Main_Content);